/* tslint:disable */
/* eslint-disable */
/**
 * User service API
 * Service for user management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhoneNumberDto
 */
export interface PhoneNumberDto {
    /**
     * User's telephone number without country code
     * @type {string}
     * @memberof PhoneNumberDto
     */
    value?: string;
    /**
     * Country code of user's telephone number
     * @type {string}
     * @memberof PhoneNumberDto
     */
    countryCode?: string;
}

/**
 * Check if a given object implements the PhoneNumberDto interface.
 */
export function instanceOfPhoneNumberDto(value: object): boolean {
    return true;
}

export function PhoneNumberDtoFromJSON(json: any): PhoneNumberDto {
    return PhoneNumberDtoFromJSONTyped(json, false);
}

export function PhoneNumberDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhoneNumberDto {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
    };
}

export function PhoneNumberDtoToJSON(value?: PhoneNumberDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'countryCode': value['countryCode'],
    };
}

